import React from 'react';
import { ColorThumb as AriaColorThumb, type ColorThumbProps } from 'react-aria-components';
import { cn } from '../utils';

export function ColorThumb(props: ColorThumbProps) {
	return (
		<AriaColorThumb
			{...props}
			style={({ defaultStyle, isDisabled }) => ({
				...defaultStyle,
				backgroundColor: isDisabled ? undefined : defaultStyle.backgroundColor,
				boxShadow: '0 0 0 1px black, inset 0 0 0 1px black'
			})}
			className={renderProps =>
				cn(
					'left-[50%] top-[50%] size-6 rounded-full border-2 border-white',
					renderProps.isFocusVisible && 'h-8 w-8',
					renderProps.isDragging && 'bg-gray-700 forced-colors:bg-[ButtonBorder]',
					renderProps.isDisabled && 'border-gray-300 bg-gray-300 forced-colors:border-[GrayText] forced-colors:bg-[GrayText]'
				)
			}
		/>
	);
}
